
import { Component, Vue } from 'vue-property-decorator'
import UploadFeedback from '@/modules/feedback/UploadFeedback.vue'

@Component({
  components: { UploadFeedback },
  props: ['response'],
})
export default class TextFeedback extends Vue {
  loadFeedback(id) {
    console.log(this.$props.response)
  }
  sendData(event) {
    console.log('U Dergua')
    console.log(this.$props.response) /* duhent ber api */

    window.location.href = '/feedback'
  }
  cancelData() {
    ;(this.$refs.formRef as HTMLFormElement).reset() /* duhent ber se ne cilin page duhet derguar */
    window.location.href = '/feedback'
  }
}
